import { useCallback, useState } from "react";

import { getBlogArticles } from "../../lib/blog-articles";

import Button from "../../components/button";
import Hero from "../../components/hero";
import NewsPostItem from "../../components/news-post-item";

import styles from "./news.module.scss";
import { getSEOPageProps } from "../../lib/seo";
import SeoMeta from "../../components/seo-meta";
import config from "../../config";

export default function NewsPage({
  initialArticles,
  totalCount,
  initialLimit,
  initialSkip,
  seo
}) {
  const [articles, setArticles] = useState(initialArticles);
  const [limit] = useState(initialLimit);
  const [skip, setSkip] = useState(initialSkip);
  const [hasMore, setHasMore] = useState(totalCount > initialArticles.length);

  const loadMore = useCallback(async () => {
    // Updated skip and
    const newSkip = skip + limit;
    const moreArticles = await getBlogArticles({ limit, skip: newSkip });
    const newArticles = [...articles, ...moreArticles.items];

    setSkip(newSkip);
    setHasMore(moreArticles.total > newArticles.length);
    setArticles(newArticles);
  }, [articles, limit, skip]);

  return (
    <>
      <div className="container">
        <SeoMeta {...seo} />
        <Hero title="News &amp; Stories" />

        <div>
          <div className={styles.NewsStoriesList}>
            {articles.map((article) => (
              <NewsPostItem
                key={article.slug}
                post={article}
                medium
                showByline
              />
            ))}
          </div>

          <div className={styles.LoadMoreWrapper}>
            {hasMore && (
              <Button rounded outline small onClick={() => loadMore()}>
                Load More
              </Button>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export async function getStaticProps() {
  try {
    const limit = 9;
    const skip = 0;
    const articles = await getBlogArticles({ limit, skip });

    return {
      props: {
        initialArticles: articles.items,
        totalCount: articles.total,
        initialLimit: limit,
        initialSkip: skip,
        seo: await getSEOPageProps({ resolvedUrl: "/news" })
      },
      revalidate: config.ISR_TIMING
    };
  } catch (e) {
    console.log(e.message);
  }
}
